/* See https://www.algolia.com/doc/integration/shopify/advanced-customization/customizing-instant-search/#hogan */

(function (algolia) {
  'use strict';
  var Hogan = algolia.externals.Hogan;

  var formatPrice = function formatPrice(value) {
    return algolia.formatMoney(Number(value) * 100);
  };

  function formattedPriceWithComparison(price, compare_at_price, price_ratio) {
    var comparing =
      Number(compare_at_price) && Number(compare_at_price) > Number(price);
    var discount_ratio = 1.0 - price_ratio;
    var res;
    if (comparing) {
      res =
        '<span class="ais-hit--price-striked"><span>' +
        formatPrice(compare_at_price) +
        '</span></span> ';
      res +=
      ' <span class="ais-hit--price-discount" style="font-weight: ' +
      Math.floor(discount_ratio * 10) * 100 +
      ';">-' +
      Math.floor(discount_ratio * 100) +
      '%</span>';
      res +=
      '<b>' + formatPrice(price) + '</b>';

    } else {
      res =
      '<b>' + formatPrice(price) + '</b>';
    }

 

    return res;
  }

  var escapeHtml = function escapeHtml(unsafe) {
    return (unsafe || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  };

  algolia.helpers = {
    formatNumber: function formatNumber(text, render) {
      return Number(render(text)).toLocaleString();
    },
    formattedPrice: function formattedPrice(text, render) {
      return formatPrice(render(text));
    },
    formattedPriceWithoutDecimals: function formattedPriceWithoutDecimals(
      text,
      render
    ) {
      return formatPrice(render(text)).replace(/\.\d+$/, '');
    },
    autocompletePrice: function autocompletePrice() {
      if (this._distinct) {
        var min = this.variants_min_price;
        var max = this.variants_max_price;
        if (min !== max) {
          return '<b>' + formatPrice(min) + ' - ' + formatPrice(max) + '</b>';
        }
      }
      return formattedPriceWithComparison(this.price, null);
    },
    instantsearchPrice: function instantsearchPrice() {
      if (this._distinct) {
        var min = this.variants_min_price;
        var max = this.variants_max_price;
        if (min !== max) {
          return '<b>' + formatPrice(min) + ' - ' + formatPrice(max) + '</b>';
        }
      }
      return formattedPriceWithComparison(
        this.price,
        this.compare_at_price,
        this.price_ratio
      );
    },
    instantTags: function instantTags() {
      return this.tags;
    },
    getBadgeTag: function getBadgeTag() {
      const tags = this.tags;
      let badgeText = '';
      tags.forEach(tag => {
        if (tag.includes('badge')) {
          const thisBadge = tag.split(':');
          badgeText = thisBadge[1];
        }
      })

      console.log("badgeText", badgeText);

      if (badgeText != '') {
        return '<p class="product-v2--tag--collections--search roboto-mono" style="display: block;">' + badgeText + '</p>'
      } else {
        return '<p></p>'
      }

    },
    instantsearchLink: function instantsearchLink() {
      var addVariantId = !this._distinct && this.objectID !== this.id;
      return (
        '/products/' +
        this.handle +
        (addVariantId ? '?variant=' + this.objectID : '')
      );
    },
    fullTitle: function fullTitle() {
      var res = this.title;
      if (
        !this._distinct &&
        this.variant_title &&
        this.variant_title !== 'Default Title' &&
        this.variant_title !== 'Default'
      ) {
        res += ' (' + this.variant_title + ')';
      }

      return escapeHtml(res);
    },
    fullHTMLTitle: function fullHTMLTitle() {
      var res = '';

      if (this._highlightResult.title && this._highlightResult.title.value) {
        res = algolia.helpers.fullEscapedAttribute(
          this._highlightResult.title.value
        );
      }

      if (
        !this._distinct &&
        this.variant_title &&
        this.variant_title !== 'Default Title' &&
        this.variant_title !== 'Default'
      ) {
        res += ' <span class="algolia-variant">(' + res + ')</span>';
      }
      return res;
    },
    buildReviews: function buildReviews() {
      
      var getUrl = window.location;
      console.log("getUrl", getUrl);
      var baseUrl = getUrl.origin;
      console.log("baseUrl", baseUrl);
      console.log("this._highlightResult.title", this);
      var html = `<p class="bc-sf-filter-product-item-reviews" style="margin: 0px;">`;
      html += `<div data-yotpolimit="9" data-product="${this.id}" id="review-carousel" class="product-v2--reviews-plp-${this.id}"></div>`;
      html += `<div class="product-v2--review-count-plp-${this.id}" style="text-align:left;"></div>`;

      //  $(document).ready(function () {
      let container = $(`.product-v2--reviews-plp-${this.id}`);

      if (container) {
        var limit = container.data('yotpolimit');
        yotpoSettings.productId = container.data('product');
        yotpoSettings.per_page = limit ? limit : yotpoSettings.per_page;
        yotpoSettings.per_page = limit ? limit : yotpoSettings.per_page;
      }

      // fetch reviews for current product
      fetchReviewsPLP(`${this.id}`, function (data_review) {
        Object.assign(yotpoSettings, {
          last_page: Math.ceil(data_review.response.pagination.total / data_review.response.pagination.per_page)
        });
        renderCollectionReviewsSummary(data_review.response.bottomline);
      });
      //}); // end document.load

      const renderCollectionReviewsSummary = (summary) => {
        var container = $(`.product-v2--review-count-plp-${this.id}`);
        let stars = "";
        let average_score = summary.average_score;
        let fullStars = Math.floor(average_score);
        let middleStars = (Math.ceil(average_score) - Math.floor(average_score)) > 0 ? 1 : 0;
        let emptyStars = (5 - Math.ceil(average_score));

        for (let s = 0; s < fullStars; s++) {
          stars += `<img src="${yotpoStars.full}" height="15"/>`;
        }

        for (let s = 0; s < middleStars; s++) {
          stars += `<img src="${yotpoStars.middle}" height="15"/>`;
        }

        for (let s = 0; s < emptyStars; s++) {
          stars += `<img src="${yotpoStars.empty}" height="15"/>`;
        }

        // don't output anything if no reviews

        var yotpoStarsDiv = document.querySelector(`.product-v2--review-summary-${this.id}`);
        console.log("yotpoStarsDiv", yotpoStarsDiv);
        if (summary.total_review > 0 && yotpoStarsDiv == null) {
          container.prepend(`
                  <div style="margin-top: 11px" class="product-v2--review-summary-${this.id} product-v2--review-summary-img">
                      <a style="color: #999999;font-size: 13px;line-height: 1.5;" href="${baseUrl + '/products/' + this.handle}">
                          ${stars} (${summary.total_review} ${summary.total_review == 1 ? 'review' : 'reviews'})
                      </a>
                  </div>
              `);
        }

      }

      //html += `</p1>`;
      return html;
    },
    fullEscapedAttribute(attribute) {
      return new DOMParser().parseFromString(attribute, 'text/html')
        .documentElement.textContent;
    },
    fullEscapedHTMLTitle: function fullEscapedHTMLTitle() {
      var res = '';

      if (this._highlightResult.title && this._highlightResult.title.value) {
        res = algolia.helpers.fullEscapedAttribute(
          this._highlightResult.title.value
        );
      }

      if (
        !this._distinct &&
        this.variant_title &&
        this.variant_title !== 'Default Title' &&
        this.variant_title !== 'Default'
      ) {
        res += ' <span class="algolia-variant">(' + res + ')</span>';
      }
      return res;
    },
    fullEscapedHTMLProductType: function fullEscapedHTMLProductType() {
      if (
        this._highlightResult.product_type &&
        this._highlightResult.product_type.value
      ) {
        return algolia.helpers.fullEscapedAttribute(
          this._highlightResult.product_type.value
        );
      } else {
        return '';
      }
    },
    fullEscapedHTMLVendor: function fullEscapedHTMLVendor() {
      if (this._highlightResult.vendor && this._highlightResult.vendor.value) {
        return algolia.helpers.fullEscapedAttribute(
          this._highlightResult.vendor.value
        );
      } else {
        return '';
      }
    },
    floor: function floor(text, render) {
      return '' + Math.floor(Number(render(text)));
    },
    ceil: function ceil(text, render) {
      return '' + Math.ceil(Number(render(text)));
    },
    sizedImage: function sizedImage(text, render) {
      var image = this._distinct ? this.product_image : this.image;
      if (!image) {
        return 'http://cdn.shopify.com/s/images/admin/no-image-compact.gif';
      }
      var size = render(text).replace(/^\s+|\s+$/g, ''); // Render and trim
      if (size === 'original') {
        return image;
      }
      return image.replace(/\/(.*)\.(\w{2,4})/g, '/$1_' + size + '.$2');
    },
  };

  [
    'pico',
    'icon',
    'thumb',
    'small',
    'compact',
    'medium',
    'large',
    'grande',
    'original',
  ].forEach(function (size) {
    algolia.helpers[size + 'Image'] = (function (_size) {
      return function () {
        var image = this._distinct ? this.product_image : this.image;

        if (!image) {
          return 'http://cdn.shopify.com/s/images/admin/no-image-compact.gif';
        }

        if (_size === 'original') {
          return image;
        }

        return image.replace(/\/(.*)\.(\w{2,4})/g, '/$1_' + _size + '.$2');
      };
    })(size); // We need to create a new scope so that the internal size has the good value.
  });

  /* Create an Hogan lambda, which doesn't respect the mustache doc */
  var helpers = algolia.assign(
    {},
    algolia.helpers,
    algolia.translation_helpers
  );
  var helpersNames = Object.keys(helpers);
  var i = helpersNames.length;
  var helpersArray = new Array(i);
  while (i--) helpersArray[i] = [helpersNames[i], helpers[helpersNames[i]]];

  algolia.hoganHelpers = helpersArray.reduce(function (res, options) {
    var name = options[0];
    var helper = options[1];

    var newRes = algolia.assign({}, res);

    newRes[name] = function () {
      return function (text) {
        var render = function (value) {
          return Hogan.compile(value, algolia.hoganOptions).render(this);
        }.bind(this);

        return helper.call(this, text, render);
      }.bind(this);
    };

    return newRes;
  }, {});
})(window.algoliaShopify);
